import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  getUserJobResponsibility,
  addOrUpdateUserJobResponsibility,
} from "../../../store/profile/actions";
import AdvertSkeleton from "../../common/components/AdvertSkeleton";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { showError } from "../../toastify";

export const JobResponsibility = (props) => {
  const {
    loading,
    getUserJobResponsibility,
    addOrUpdateUserJobResponsibility,
  } = props;

  const [userJobResponsibility, setUserJobResponsibility] = useState(null);
  const [jobResponsibilities, setJobResponsibilities] = useState("");
  const [dutiesBeyondJobResponsibilities, setDutiesBeyondJobResponsibilities] =
    useState("");
  const [completeness, setCompleteness] = useState(false);
  const [clarity, setClarity] = useState(false);
  const [relevance, setRelevance] = useState(false);
  const [additionalDuties, setAdditionalDuties] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  useEffect(() => {
    getUserJobResponsibility(setUserJobResponsibility);
  }, []);

  useEffect(() => {
    setJobResponsibilities(userJobResponsibility?.jobResponsibilities || "");
    setDutiesBeyondJobResponsibilities(
      userJobResponsibility?.dutiesBeyondJobResponsibilities || ""
    );
    // setCompleteness(userJobResponsibility?.completeness || "");
    // setClarity(userJobResponsibility?.clarity || "");
    // setRelevance(userJobResponsibility?.relevance || "");
    // setAdditionalDuties(userJobResponsibility?.additionalDuties || "");
  }, [userJobResponsibility]);

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    userJobResponsibilityHasError: false,
    dutiesBeyondJobResponsibilitiesHasError: false,
    completenessHasError: false,
    clarityHasError: false,
    relevanceHasError: false,
    additionalDutiesHasError: false,
  });

  const formValidator = () => {
    const error = {
      userJobResponsibilityHasError: false,
      completenessHasError: false,
      clarityHasError: false,
      relevanceHasError: false,
      additionalDutiesHasError: false,
      dutiesBeyondJobResponsibilitiesHasError: false,
      hasError: false,
    };
    if (!jobResponsibilities) {
      error.userJobResponsibilityHasError = true;
      error.hasError = true;
    }

    if (!dutiesBeyondJobResponsibilities) {
      error.dutiesBeyondJobResponsibilitiesHasError = true;
      error.hasError = true;
    }

    if (!completeness && showConfirmModal) {
      error.completenessHasError = true;
      error.hasError = true;
    }
    if (!clarity && showConfirmModal) {
      error.clarityHasError = true;
      error.hasError = true;
    }
    if (!relevance && showConfirmModal) {
      error.relevanceHasError = true;
      error.hasError = true;
    }
    if (!additionalDuties && showConfirmModal) {
      error.additionalDutiesHasError = true;
      error.hasError = true;
    }
    setErrors(error);

    if (error.hasError) {
      showError("Make sure all fields are filled");
      return true;
    }
    return false;
  };

  const handleSubmit = (e) => {
    if (!formValidator()) {
      addOrUpdateUserJobResponsibility(
        {
          id: userJobResponsibility?.id || "",
          jobResponsibilities: jobResponsibilities,
          dutiesBeyondJobResponsibilities,
        },
        setIsLoading,
        setUserJobResponsibility,
        setShowConfirmModal
      );
    }
  };

  return (
    <>
      <Card className={`border rounded mb-3`} elevation={1} id="publications">
        <CardContent>
          {loading && !isLoading ? (
            <AdvertSkeleton />
          ) : (
            <div className="container-fluid">
              <div className="d-flex flex-row justify-content-between align-items-center bg-light border px-3 py-1">
                {/* title */}
                <div>
                  <Typography variant="h5" style={{ color: "#078ece" }}>
                    Current Job Responsibilities
                  </Typography>
                </div>
                {userJobResponsibility &&
                  +userJobResponsibility?.isApproved === 0 && (
                    <span className={`badge badge-warning`}>
                      Awaiting Supervisor Approval
                    </span>
                  )}
                {userJobResponsibility &&
                  +userJobResponsibility?.isApproved === 1 && (
                    <span className={`badge badge-success`}>
                      Supervisor Approved
                    </span>
                  )}
                {userJobResponsibility &&
                  +userJobResponsibility?.isApproved === 2 && (
                    <span className={`badge badge-danger`}>
                      Supervisor Declined
                    </span>
                  )}
              </div>
              <div className="px-md-0 mt-4">
                <form onSubmit={handleSubmit}>
                  <div className="form-group col-12">
                    <TextField
                      fullWidth
                      focused
                      label="Current Job Responsibilities"
                      placeholder="Please provide a detailed description of your current job responsibilities. This information will enable an evaluation of your current job function and gain a clearer understanding of the knowledge and skills set you regularly apply in your daily work. "
                      id="jobResponsibilities"
                      value={jobResponsibilities || ""}
                      size="small"
                      multiline
                      minRows={10}
                      onChange={(e) => {
                        setJobResponsibilities(e.target.value);
                        setErrors({
                          ...errors,
                          userJobResponsibilityHasError: false,
                        });
                      }}
                      error={errors.userJobResponsibilityHasError}
                    />

                    {errors.userJobResponsibilityHasError && (
                      <small className="text-danger">
                        Job responsibilities is required
                      </small>
                    )}
                  </div>

                  <div className="form-group col-12">
                    <TextField
                      fullWidth
                      focused
                      label="Additional Responsibilities Beyond Job Description"
                      placeholder="Please include any tasks or functions you carry out that are not reflected in your formal job description. "
                      id="dutiesBeyondJobResponsibilities"
                      value={dutiesBeyondJobResponsibilities || ""}
                      size="small"
                      multiline
                      minRows={10}
                      onChange={(e) => {
                        setDutiesBeyondJobResponsibilities(e.target.value);
                        setErrors({
                          ...errors,
                          dutiesBeyondJobResponsibilitiesHasError: false,
                        });
                      }}
                      error={errors.dutiesBeyondJobResponsibilitiesHasError}
                    />

                    {errors.dutiesBeyondJobResponsibilitiesHasError && (
                      <small className="text-danger">
                        Additional Responsibilities Beyond Job Description is
                        required
                      </small>
                    )}
                  </div>
                  <div className="alert alert-info">
                    Refer to the table below for examples of what makes a strong
                    response to draft your answer.
                  </div>

                  <div className="container mt-4">
                    <div className="d-flex flex-row justify-content-end align-items-end bg-light border px-3 py-1">
                      <Button
                        variant="contained"
                        type="button"
                        className={`px-5 float-right`}
                        disabled={
                          isLoading ||
                          (userJobResponsibility &&
                            +userJobResponsibility?.isApproved === 1)
                        }
                        onClick={() => {
                          if (!formValidator()) {
                            setShowConfirmModal(true);
                          }
                        }}
                      >
                        {isLoading
                          ? "Wait..."
                          : !!userJobResponsibility
                          ? "Update"
                          : "Save"}
                      </Button>
                    </div>

                    <h5 className="mt-5">
                      Example of Weak and Strong Responses
                    </h5>
                    <table className="table table-bordered mt-3 table-sm">
                      <thead className="table-primary">
                        <tr>
                          <th>Weak</th>
                          <th>Strong</th>
                          <th>Reasons for Strong Response</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Assist with reporting and coordination</td>
                          <td>
                            Compile and submit monthly activity reports for the
                            department, coordinating with unit heads to gather
                            data and ensure accuracy. Also lead internal
                            coordination meetings every Friday to track progress
                            on key projects.
                          </td>
                          <td>
                            Shows how the responsibility is done, who is
                            involved, and what value it brings.
                          </td>
                        </tr>
                        <tr>
                          <td>Support other teams when needed</td>
                          <td>
                            Serve as VIP logistics coordinator for the National
                            Induction Program, a training course for civil
                            servants. Arranging the accommodation,
                            transportation, and food requirements for VIPs. Led
                            two staff to support these duties, although this is
                            not part of my formal role as procurement officer
                          </td>
                          <td>
                            <strong>
                              Specifies tasks beyond the formal JD
                            </strong>{" "}
                            and shows <strong>initiative</strong> and{" "}
                            <strong>cross-functional support</strong>.
                          </td>
                        </tr>
                        <tr>
                          <td>Handle customer service</td>
                          <td>
                            Resolve customer complaints through phone and email
                            by actively listening, identifying issues, and
                            coordinating with technical staff to ensure
                            resolution. Maintain detailed logs of issues and
                            track common concerns to inform service improvements
                          </td>
                          <td>
                            Highlights{" "}
                            <strong>
                              both the responsibilities and skills{" "}
                            </strong>{" "}
                            (communication, problem-solving, documentation)
                            applied.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {showConfirmModal && (
                    <ConfirmationDialog
                      alignContent="left"
                      size="xl"
                      confirmationDialog={showConfirmModal}
                      message={
                        <>
                          <p>
                            <div className="alert alert-info">
                              Responses that do not meet the following criteria
                              may be returned or declined by your supervisor, so
                              please review them carefully before submission.
                            </div>
                          </p>
                          <p>
                            <h5>Checklist for Drafting Strong Responses</h5>
                            <table className="table table-bordered mt-3 table-sm">
                              <thead className="table-dark">
                                <tr>
                                  <th>Criteria</th>
                                  <th>Guiding Questions</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Completeness</td>
                                  <td>
                                    <strong>
                                      Have you included all key
                                      responsibilities, including those not
                                      listed in your original JD?
                                    </strong>
                                  </td>
                                  <td align="right">
                                    <FormControlLabel
                                      className="mb-0"
                                      error={errors.completenessHasError}
                                      control={
                                        <Checkbox
                                          color={
                                            errors.completenessHasError
                                              ? "error"
                                              : "primary"
                                          }
                                          sx={{
                                            color: errors.completenessHasError
                                              ? "red"
                                              : "",
                                          }}
                                          checked={completeness || false}
                                          onClick={() => {
                                            setCompleteness(!completeness);

                                            setErrors({
                                              ...errors,
                                              completenessHasError: false,
                                            });
                                          }}
                                        />
                                      }
                                      label=""
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Clarity</td>
                                  <td>
                                    Is the information{" "}
                                    <strong>clearly written</strong>, avoiding
                                    vague or generic language?
                                  </td>
                                  <td align="right">
                                    <FormControlLabel
                                      className="mb-0"
                                      control={
                                        <Checkbox
                                          checked={clarity || false}
                                          onClick={() => {
                                            setClarity(!clarity);
                                            setErrors({
                                              ...errors,
                                              clarityHasError: false,
                                            });
                                          }}
                                          sx={{
                                            color: errors.clarityHasError
                                              ? "red"
                                              : "",
                                          }}
                                        />
                                      }
                                      label=""
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Relevance</td>
                                  <td>
                                    Do the responsibilities listed{" "}
                                    <strong>
                                      reflect your current, actual work?
                                    </strong>
                                    ?
                                  </td>
                                  <td align="right">
                                    <FormControlLabel
                                      className="mb-0"
                                      control={
                                        <Checkbox
                                          checked={relevance || false}
                                          onClick={() => {
                                            setRelevance(!relevance);
                                            setErrors({
                                              ...errors,
                                              relevanceHasError: false,
                                            });
                                          }}
                                          sx={{
                                            color: errors.relevanceHasError
                                              ? "red"
                                              : "",
                                          }}
                                        />
                                      }
                                      label=""
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>Additional responsibilities</td>
                                  <td>
                                    Are <strong>extra roles</strong>{" "}
                                    (committees, coordination, special projects)
                                    captured in your response?
                                  </td>
                                  <td align="right">
                                    <FormControlLabel
                                      className="mb-0"
                                      control={
                                        <Checkbox
                                          checked={additionalDuties || false}
                                          onClick={() =>
                                            setAdditionalDuties(
                                              !additionalDuties
                                            )
                                          }
                                          sx={{
                                            color:
                                              errors.additionalDutiesHasError
                                                ? "red"
                                                : "",
                                          }}
                                        />
                                      }
                                      label=""
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </p>
                        </>
                      }
                      setConfirmationDialog={setShowConfirmModal}
                      onYes={() => {
                        handleSubmit();
                      }}
                    />
                  )}
                </form>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
};

const mapStateToProps = ({ user, env, loading, onWait }) => ({
  user,
  env,
  loading,
  onWait,
});

export default connect(mapStateToProps, {
  getUserJobResponsibility,
  addOrUpdateUserJobResponsibility,
})(JobResponsibility);
